import { IGroup, Item } from '../graphQL/commons'
import { ICartGroup, ICartProduct } from '../interfaces'

/**
 * Cast an Item array to it's equivalent ICartProduct array
 * @param source: Item[]
 * @param autoAdd: boolean
 * @internal
 */
export const sanitizeCartProducts = (
  source: Item[],
  autoAdd: boolean,
  freegoodsAsSubitem: boolean,
  disableFreeGoodsAsDiscount: boolean,
): ICartProduct[] => {
  return source.map((item) => {
    const { quantity, promotionalQty, discounts = 0, price } = item
    const newQuantity = freegoodsAsSubitem
      ? quantity - promotionalQty
      : quantity
    const minQtyAllowed = autoAdd && !freegoodsAsSubitem ? promotionalQty : 0
    const newDiscounts =
      !freegoodsAsSubitem || disableFreeGoodsAsDiscount
        ? discounts
        : discounts - promotionalQty * price

    return {
      ...item,
      quantity: newQuantity,
      inCartQuantity: quantity,
      minQtyAllowed,
      discounts: newDiscounts,
    }
  })
}

/**
 * Cast an IGroup array to it's equivalent ICartGroup array
 * @param source: IGroup[]
 * @param autoAdd: boolean
 * @internal
 */
export const sanitizeCartGroups = (
  source: IGroup[],
  autoAdd: boolean,
  cartGroupingTotals: boolean,
  freegoodsAsSubitem: boolean,
  disableFreeGoodsAsDiscount: boolean,
): ICartGroup[] => {
  return source.map(({ groupBy, items, total, subtotal = 0 }) => {
    return {
      groupBy,
      total,
      subtotal,
      items: sanitizeCartProducts(
        items,
        autoAdd,
        freegoodsAsSubitem,
        disableFreeGoodsAsDiscount,
      ),
      visibleTotal: cartGroupingTotals ? total : subtotal,
    }
  })
}
